import React, { useRef } from "react";
import DataTable from "@/components/DataTable";
import { appliedNamingGroupsApi } from "@/apis/apiCollection";
import { useTranslation } from "@/langs/useTranslation";
import { useUpdateEffect } from "ahooks";

function mergeRefs(ref1, ref2) {
  return ref => {
    if (ref1 && "current" in ref1) ref1.current = ref;
    if (ref2 && "current" in ref2) ref2.current = ref;
  };
}

export const DeviceNamingMerchantsDatatable = React.forwardRef(
  ({ className, style, keyword, id, children, onLoaded }, ref) => {
    const { t } = useTranslation();
    const tableRef = useRef(null);

    const columns = [
      {
        width: 70,
        searchable: false,
        className: "center",
        title: t({ defaultMessage: "序号" }),
        render: (data, type, row, meta) => {
          return meta.row + 1;
        }
      },
      {
        data: "name",
        title: t({ defaultMessage: "门店名称" })
      }
    ];

    const ajax = (data, callback, settings) => {
      return appliedNamingGroupsApi({
        namingRuleId: id,
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        callback({
          data: res.groups,
          draw: data.draw,
          recordsFiltered: res.recordsTotal,
          recordsTotal: res.recordsTotal
        });
      });
    };

    useUpdateEffect(() => {
      tableRef.current?.api().search(keyword).draw();
    }, [keyword]);

    return (
      <DataTable
        ref={mergeRefs(ref, tableRef)}
        paging={false}
        options={{
          serverSide: false,
          searching: true
        }}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        autoLoad
        showFilter={false}
        showCheckAll={false}
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
